export const isEditableElement = (element: EventTarget | null): boolean => {
  if (
    element instanceof HTMLInputElement ||
    element instanceof HTMLTextAreaElement ||
    element instanceof HTMLSelectElement
  ) {
    return true;
  }

  if (!(element instanceof Element)) {
    return false;
  }

  if (element instanceof HTMLElement && element.isContentEditable) {
    return true;
  }

  return element.closest("[contenteditable='true']") != null;
};
